import { Link, useLocation } from "react-router-dom";
import { Plus } from "lucide-react";

export default function MobileFab() {
  const location = useLocation();
  // Hide on form & auth pages where it would overlap primary CTAs
  const hidden = ["/post", "/login", "/register", "/forgot-password", "/reset-password", "/auth/callback"].some((p) => location.pathname.startsWith(p)) || location.pathname.startsWith("/edit");
  if (hidden) return null;
  return (
    <Link
      to="/post"
      data-testid="mobile-fab-post"
      className="md:hidden fixed bottom-6 right-6 z-40 bg-[#0000EE] text-white border-2 border-black hard-shadow w-14 h-14 flex items-center justify-center no-underline hover:no-underline hover:bg-[#0000AA]"
      aria-label="Post new ad"
    >
      <Plus size={28} strokeWidth={3} />
    </Link>
  );
}
